<template>
  <div class="asc-mx-status-label">
    <asc-label size="sm" :value="value"></asc-label>
  </div>
</template>

<script>
import AscLabel from './AscLabel'

export default {
  name: 'AscMxStatusLabel',

  components: {
    AscLabel,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
  },
}
</script>
